import { render, staticRenderFns } from "./LookupCombo.vue?vue&type=template&id=497913a8&scoped=true"
import script from "./LookupCombo.vue?vue&type=script&lang=js"
export * from "./LookupCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497913a8",
  null
  
)

export default component.exports